module.exports = __webpack_public_path__ + "static/day17-063279893708b05333eb1c84fc85f4b2.png";